import React from 'react';
import PropTypes from 'prop-types';
import { colors } from 'common/styles/style-constants';

const ExternalLinkSvg = ({ color, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    role="presentation"
    height={height}
  >
    <g fill={color}>
      <path d="M9.11109 8.66667C9.11109 8.91358 8.91336 9.11131 8.66645 9.11131H1.33344C1.08653 9.11131 0.888805 8.91358 0.888805 8.66667V1.33366C0.888805 1.08675 1.08653 0.889025 1.33344 0.889025H4.22205V0.000244141H1.33344C0.59271 0.000244141 0 0.592929 0 1.33369V8.6667C0 9.40743 0.592685 10.0001 1.33344 10.0001H8.66645C9.40718 10.0001 9.99989 9.40745 9.99989 8.6667V5.77808H9.11111L9.11109 8.66667Z" />
      <path d="M5.77755 2.47246e-05V0.888805H8.48097L4.98706 4.38272L5.61688 5.01254L9.11079 1.51863V4.22205H9.99958V0L5.77755 2.47246e-05Z" />
    </g>
  </svg>
);

ExternalLinkSvg.defaultProps = {
  color: colors.gray8,
  height: '10px',
};

ExternalLinkSvg.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
};

export default ExternalLinkSvg;
